/**
 * JourneyQueueSvgIcons.js
 *
 * SVG path strings for all 8 transport mode icons used by JourneyQueue markers.
 * Car, walking, bicycle, aircraft paths are ported from offertraq-18's queue_class.js.
 * Transit, motorcycle, rideshare, golf_cart, prm_vehicle paths are new SVGs.
 *
 * Each path is designed for a ~100×100 viewBox; L.divIcon scales via CSS.
 * Rotation is applied via CSS transform: rotate({heading}deg) on the wrapper div.
 *
 * ADR-002: These are static SVG paths — no Google Maps SymbolPath dependency.
 */

// ── Ported from offertraq-18/public/queue_class.js ───────────────────────────

/** Car/driving marker — compact sedan silhouette */
export const DRIVING_PATH =
  "M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759" +
  "c3.116,0,5.644-2.527,5.644-5.644V6.584C23.044,3.467,20.518,0,17.402,0z " +
  "M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z " +
  "M20.625,10.773c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z " +
  "M3.748,21.713v4.492l-2.73-0.349V14.502L3.748,21.713z " +
  "M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z " +
  "M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z " +
  "M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z";

/** Walking / pedestrian figure */
export const WALKING_PATH =
  "M33.53,71.7c2.2-1.03,4.53-2.11,6.85-3.51l-2.43-15.44c-2.04,2.06-4.4,4.06-8.37,5.59l-0.23,0.08" +
  "c-6.81,1.68-10.64,0.32-15.93-1.56C8.95,55.27,4.47,53.7,0,52.12l4.9-14.75l12.61,4.44l1.76,0.67" +
  "c0.93,0.26,1.81,0.63,2.64,0.98c1.07,0.45,2.02,0.85,2.3,0.72c1.36-0.65,2.74-2.2,4.34-4" +
  "c3.94-4.43,9.02-10.13,19.94-10.84C68.9,28,68.46,29.04,83.02,43.76l7.64,9.67l-9.63,9.19" +
  "c-4.22-4.26-7.75-9.51-11.75-14c-1.57-1.77-2.97-3.34-4.62-4.07c-1.01-0.44-2.49-0.44-4.22-0.4" +
  "l3.88,20.97c0.44,2.32,0.51,4.53,0.13,6.59c-0.33,1.8-1.01,3.47-2.08,5c1.96,6.46,4.56,14.38,7.26,22.13" +
  "c2.71,7.78,5.55,15.45,7.96,21.37l1.09,2.67l-16.15-0.09l-0.54-1.04c-2.44-4.71-5.07-10.89-7.54-17.35" +
  "c-2.61-6.82-5.05-13.97-6.91-20.05c-2.26,0.65-4.72,1.4-6.99,2.14c-2.26,0.74-4.23,1.46-5.43,2.02" +
  "c-0.26,0.12-0.6,0.87-0.97,1.68l-0.11,0.24c-0.35,0.75-0.5,1.56-0.55,2.43c-0.06,0.98,0,2.07,0.06,3.25" +
  "c0,8.78,0.59,17.91,0.87,26.72l-15.34-0.05l-0.98-24.41c-0.03-0.72-0.05-1.08-0.07-1.42l0-0.03" +
  "c-0.06-1.04-0.11-2.04-0.13-3.14c-0.01-1.09,0.02-2.17,0.14-3.24C19.44,78.27,25.8,75.3,33.53,71.7L33.53,71.7z" +
  "M33.23,1.4c3.15-1.54,6.88-1.89,10.44-0.67c3.58,1.22,6.32,3.78,7.86,6.93c1.54,3.15,1.89,6.88,0.67,10.44" +
  "c-1.22,3.58-3.78,6.32-6.93,7.86c-3.15,1.54-6.88,1.89-10.44,0.67c-3.58-1.22-6.32-3.78-7.86-6.93" +
  "c-1.54-3.15-1.89-6.88-0.67-10.44C27.52,5.69,30.08,2.95,33.23,1.4L33.23,1.4z";

/** Bicycle / cycling */
export const CYCLING_PATH =
  "M99.83,67.01c12.72,0,23.05,10.32,23.05,23.05c0,12.72-10.32,23.05-23.05,23.05s-23.05-10.32-23.05-23.05" +
  "c0-8.21,3.56-14.68,10.02-18.76l-5.69-9.56h-15c1.52-3.28,2.47-6.09,2.28-7.7h15.32" +
  "c0.63,0,1.22,0.17,1.74,0.47l1.61-3.35l0.36-0.04l0,0c0.14-0.02,0.29-0.04,0.44-0.06" +
  "c4.12-0.77,6.58-3.37,7.6-6.5c0.46-1.41,0.58-2.92,0.39-4.39c-0.18-1.43-0.67-2.83-1.42-4.07" +
  "c-0.33-0.54-0.71-1.05-1.13-1.53h3.83v0.02c0.49,0,0.99,0.11,1.47,0.33c1.74,0.81,2.49,2.88,1.67,4.62" +
  "L90.1,60.96l3.9,6.8C95.9,67.25,97.86,67.01,99.83,67.01L99.83,67.01z" +
  "M23.05,67.01c12.73,0,23.05,10.32,23.05,23.05c0,12.72-10.32,23.05-23.05,23.05C10.32,113.11,0,102.78,0,90.06" +
  "c0-12.73,10.32-23.05,23.05-23.05z" +
  "M81.6,0c5.49,0,9.94,4.45,9.94,9.94c0,5.49-4.45,9.94-9.94,9.94c-5.49,0-9.94-4.45-9.94-9.94" +
  "C71.66,4.45,76.11,0,81.6,0L81.6,0z";

/** Aircraft / flying */
export const FLYING_PATH =
  "M362.985,430.724l-10.248,51.234l62.332,57.969l-3.293,26.145l-71.345-23.599l-2.001,13.069" +
  "l-2.057-13.529l-71.278,22.928l-5.762-23.984l64.097-59.271l-8.913-51.359l0.858-114.43" +
  "l-21.945-11.338l-189.358,88.76l-1.18-32.262l213.344-180.08l0.875-107.436l7.973-32.005" +
  "l7.642-12.054l7.377-3.958l9.238,3.65l6.367,14.925l7.369,30.363v106.375l211.592,182.082" +
  "l-1.496,32.247l-188.479-90.61l-21.616,10.087l-0.094,115.684";

// ── New icons for Rail 8 transport modes ─────────────────────────────────────

/**
 * Transit / bus icon — side-view city bus silhouette.
 * Viewbox: 0 0 100 60
 */
export const TRANSIT_PATH =
  "M10,5 h80 a10,10 0 0 1 10,10 v25 a10,10 0 0 1 -10,10 h-5 v5 h-10 v-5 H25 v5 H15 v-5 h-5" +
  " a10,10 0 0 1 -10,-10 V15 a10,10 0 0 1 10,-10 Z" +
  "M20,35 m-8,0 a8,8 0 1,0 16,0 a8,8 0 1,0 -16,0 Z" +
  "M80,35 m-8,0 a8,8 0 1,0 16,0 a8,8 0 1,0 -16,0 Z" +
  "M15,15 h70 v15 H15 Z";

/**
 * Motorcycle / rideshare motorcycle icon — compact profile silhouette.
 * Viewbox: 0 0 100 60
 */
export const MOTORCYCLE_PATH =
  "M30,45 a18,18 0 1,0 36,0 a18,18 0 1,0 -36,0" +
  "M85,45 a15,15 0 1,0 30,0 a15,15 0 1,0 -30,0" +
  "M55,45 L68,20 L80,22 L82,28 L72,30 L62,45 Z" +
  "M50,45 L45,38 L35,35 L30,25 L40,18 L50,28 L58,35 L55,45 Z" +
  "M65,18 a6,6 0 1,0 12,0 a6,6 0 1,0 -12,0";

/**
 * Rideshare car — same sedan profile as driving but with a badge strip.
 * Viewbox: 0 0 48 48
 */
export const RIDESHARE_PATH = DRIVING_PATH;

/**
 * Golf cart — compact open-cab vehicle silhouette.
 * Viewbox: 0 0 100 70
 */
export const GOLF_CART_PATH =
  "M10,55 a12,12 0 1,0 24,0 a12,12 0 1,0 -24,0 Z" +
  "M65,55 a12,12 0 1,0 24,0 a12,12 0 1,0 -24,0 Z" +
  "M22,40 h55 l8,15 h-70 Z" +
  "M22,40 L30,15 h30 l8,12 L55,35 Z" +
  "M30,15 L28,5 h25 v10 Z" +
  "M55,35 L80,30 L85,40 Z";

/**
 * PRM (Persons with Reduced Mobility) electric buggy / mobility vehicle.
 * Compact side silhouette of a motorised wheelchair / airport buggy.
 * Viewbox: 0 0 100 80
 */
export const PRM_VEHICLE_PATH =
  "M15,60 a15,15 0 1,0 30,0 a15,15 0 1,0 -30,0 Z" +
  "M70,60 a12,12 0 1,0 24,0 a12,12 0 1,0 -24,0 Z" +
  "M30,55 h45 l5,-15 H35 Z" +
  "M35,40 L40,10 h20 v10 h10 l5,20 Z" +
  "M20,30 h15 v8 H20 Z" +
  "M40,0 a8,8 0 1,0 16,0 a8,8 0 1,0 -16,0 Z";

// ── Icon lookup map ───────────────────────────────────────────────────────────

/** Map movement_mode → SVG path string */
export const SVG_ICONS = {
  flying:      FLYING_PATH,
  driving:     DRIVING_PATH,
  transit:     TRANSIT_PATH,
  cycling:     CYCLING_PATH,
  motorcycle:  MOTORCYCLE_PATH,
  rideshare:   RIDESHARE_PATH,
  golf_cart:   GOLF_CART_PATH,
  prm_vehicle: PRM_VEHICLE_PATH,
  walking:     WALKING_PATH,
};

/** Map movement_mode → approximate SVG viewBox for correct scaling */
export const SVG_VIEWBOXES = {
  flying:      "0 0 560 560",
  driving:     "0 0 24 48",
  transit:     "0 0 100 60",
  cycling:     "0 0 123 114",
  motorcycle:  "0 0 100 70",
  rideshare:   "0 0 24 48",
  golf_cart:   "0 0 100 70",
  prm_vehicle: "0 0 100 80",
  walking:     "0 0 91 135",
};

// ── Alert colors ──────────────────────────────────────────────────────────────

export const ALERT_COLORS = {
  green:  "#10B981",  // on-time / normal
  amber:  "#F59E0B",  // paused / attention
  red:    "#EF4444",  // high risk / timeout
  purple: "#7C3AED",  // GDS airline PNR passenger
  blue:   "#2196F3",  // worker / escort (DispatchTask)
};
